import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ModalController, ModalOptions, AlertController, LoadingController } from 'ionic-angular';
import {ViewChild} from '@angular/core';
import {AutoCompleteComponent} from 'ionic2-auto-complete';
import { EntidadServiceProvider} from '../../providers/entidad-service/entidad-service';
import { EmpleadoServiceProvider} from '../../providers/empleado-service/empleado-service';
import { MovimientocarteraServiceProvider} from '../../providers/movimientocartera-service/movimientocartera-service';

import { EnviocorreoPage } from '../enviocorreo/enviocorreo';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';

/**
 * Generated class for the MovimientoCarteraPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-movimiento-cartera',
  templateUrl: 'movimiento-cartera.html',
  providers: [EntidadServiceProvider, EmpleadoServiceProvider ]
})
export class MovimientoCarteraPage {

  @ViewChild('operador') operador: AutoCompleteComponent
  @ViewChild('proveedor') proveedor: AutoCompleteComponent
  @ViewChild('destino') destino: AutoCompleteComponent
  titulo:String='Consulta de Items';
  filtro:String='';
  cac_movcar={};
  listcac_movcar=[];
  listcac_movcar_estatica=[];
  carteras=[];
  tdoctes=[];
  pet: string = "ingreso";
  loading;

  constructor(public navCtrl: NavController, public navParams: NavParams, 
  	public entidadService: EntidadServiceProvider, public empleadoService:EmpleadoServiceProvider,
    public movcarService : MovimientocarteraServiceProvider,
  	public alertCtrl: AlertController, public loadingCtrl: LoadingController, public modalCtrl: ModalController,
    public authService : AuthServiceProvider) {

    this.entidadService.idtentidad = 2; //CONDOMINOS
    //var detTesoreria=[];
    //detTesoreria.push({
    //  iddoctes:0,
    //  idtdoctes:6,
    //  idcuenta:1,
    //  referencia:"",
    //  valor:0,
    //  idestado:0
    //});
    //this.cac_movcar["detalleTesoreria"]= detTesoreria;
    this.agregarTesoreria([]);
  }

  calcularTotalTesoreria(detalle){
    let valdoctes:number = 0;
    for (var i = 0; i < detalle.length; ++i) {
      if(detalle[i].idestado == 0)
      valdoctes += parseFloat(detalle[i].valor);
    }
    return valdoctes;
  }

  agregarTesoreria(detalle){
    let total = parseFloat(this.cac_movcar["valtotal"]);
    let valdoctes = this.calcularTotalTesoreria(detalle);

    var nuevaLinea = {
      iddoctes:0,
      idtdoctes:6,
      idcuenta:0,
      referencia:"",
      valor: (total-valdoctes > 0 ? total-valdoctes : 0).toFixed(2),
      idestado:0
    };
    this.getCuentas(nuevaLinea);
    detalle.push(nuevaLinea);

    this.cac_movcar["detalleTesoreria"]= detalle;
  }

  ionViewDidLoad() {
    this.movcarService.getDocumentoTesoreria(1).subscribe(val => {
      this.tdoctes = [];
        for (var i = 0; i < val.length; i++) {
          this.tdoctes.push(val[i]);
        }
      });
    this.nuevo();
  }

  nuevo(){
    var tzoffset = (new Date()).getTimezoneOffset() * 60000;
    //this.cac_movcar = [];
    this.cac_movcar["id"]=0;
    
    this.cac_movcar["fecha"] = (new Date(Date.now() - tzoffset)).toISOString() ;

    this.cac_movcar["operador"] = this.authService.usuario.entidad;
    this.cac_movcar["identidade"]= this.authService.usuario.identidad;
    //this.cac_movcar["idtdoctes"] = 6;
    //this.getCuentas();
    //this.cac_movcar["idcuenta"] = 1;
    this.cac_movcar["idtmovcar"]=1;
    this.cac_movcar["idempresa"]=1;
    this.cac_movcar["idestado"]=0;
    this.cac_movcar["observacion"]= "";
    this.cac_movcar["idmovimiento"]= null;
    this.cac_movcar["detalle"]= null;
    this.cac_movcar["identidadp"] = null;
    this.carteras=[];
    if(this.operador != undefined) this.operador.setValue(this.cac_movcar["operador"]);
    if(this.proveedor != undefined) this.proveedor.setValue("");
    if(this.destino != undefined) this.destino.setValue("");
    this.cac_movcar["valtotal"] = 0;
    this.cac_movcar["valdeuda"] = 0;
    this.cac_movcar["valsaldo"] = 0;
    this.cac_movcar["sn_destino"] = false;

    this.agregarTesoreria([]);
  }

  getCuentas(doctes){ 
    this.movcarService.getCuentas(doctes["idtdoctes"]).subscribe(val => {
      if(val != undefined){
          var cuentas = [];
          var encontro=false;
          for (var i = 0; i < val.length; i++) {
            if( doctes["idcuenta"] == 0) doctes["idcuenta"] = val[i].id;
            if( doctes["idcuenta"] == val[i].id) encontro=true;
            cuentas.push(val[i]);
          }
          if(!encontro) doctes["idcuenta"] = cuentas[0].id;

          doctes["cuentas"] = cuentas;
      }
    });
  }

  seleccionarOperador(evento)
  {
  	this.operador.setValue(evento.descripcion);
    this.cac_movcar["operador"] = evento.descripcion;
  	this.cac_movcar["identidade"]= evento.id;
  }

  seleccionarProveedor(evento)
  {
    this.nuevo();
    let descripcion = evento.descripcion + (evento.iddepartamento == null ? '' : ' - (' + evento.ndepartamento + (evento.codigodep.length == 0 ? "" : " - " + evento.codigodep) + ')');
  	this.proveedor.setValue(descripcion);
    this.cac_movcar["proveedor"] = descripcion;
  	this.cac_movcar["identidadp"]= evento.id;
    this.cac_movcar["iddepartamento"]= evento.iddepartamento;
    this.getCarteras();
  }

  seleccionarDestino(evento)
  {
    this.destino.setValue(evento.descripcion);
    this.cac_movcar["destinatario"] = evento.descripcion;
    this.cac_movcar["identidadd"]= evento.id;
  }

  getCarteras() {
  	if(this.cac_movcar["identidadp"] === undefined || this.cac_movcar["identidadp"] === null){
	  	let alert = this.alertCtrl.create({
	      title: 'Validacion de datos',
	      subTitle: 'Seleccione el condómino o departamento para buscar carteras pendientes',
	      buttons: ['OK']
	    });
	    alert.present();
  	}
  	else{
      //var tzoffset = (new Date()).getTimezoneOffset() * 60000;
      var fecha = new Date(Date.now());

  		this.movcarService.getCarteras(this.cac_movcar["identidadp"], this.cac_movcar["iddepartamento"]).subscribe(val => {

        this.carteras = [];
        var totDeuda=0, totSaldo=0;
        for (var i = 0; i < val.length; i++) {
          totDeuda += (new Date(val[i].fechaini) <= fecha ? parseFloat(val[i].valdeuda) : 0);
          totSaldo += parseFloat(val[i].valsaldo);
          this.carteras.push({
              pagar: (new Date(val[i].fechaini) <= fecha),
              idmovcar:0,
              fila: i+1,
              idcartera: val[i].idcartera,
              fechaini: val[i].fechaini,
              fechacar: val[i].fechacar,
              ndepartamento: val[i].ndepartamento,
              codigodep: val[i].codigodep,
              concepto: val[i].concepto,
              medida: val[i].medida,
              cantidad: val[i].idconcepto == 1 ? 1 : val[i].cantidad,
              deuda: val[i].valdeuda,
              //valor: 0,
              valor: new Date(val[i].fechaini) <= fecha ? val[i].valdeuda : 0,
              valsaldo: val[i].valsaldo,
              idestado:0
            });
          this.cac_movcar["valtotal"] = totDeuda.toFixed(2);
          this.cac_movcar["valdeuda"] = totDeuda.toFixed(2);
          this.cac_movcar["valsaldo"] = totSaldo.toFixed(2);
        }
        this.cac_movcar["detalle"]= this.carteras; 

        for (var j = 0; j < this.cac_movcar["detalleTesoreria"].length; ++j) {
          if(j == 0 )
            this.cac_movcar["detalleTesoreria"][j].valor = totDeuda.toFixed(2);
          else this.cac_movcar["detalleTesoreria"].splice(j, 1);
        }
      });
  	}
  }

  actualizarSaldo(item){
    item.valor = (item.pagar ? item.deuda : 0);
    item.idestado = (item.pagar || this.cac_movcar["id"] == 0) ? 0 : 1;
  }

  calcularTotales(item){

    item.idestado = ( item.valor==0 && this.cac_movcar["id"]!=0 ) ? 1 : 0;
    item.pagar = (item.valor >0);
    if(parseFloat(item.valor) > parseFloat(item.deuda)){
      item.valor = parseFloat(item.deuda).toFixed(2);
    }
    else{
      var valtotal= this.calcularTotalMovimiento();
      if(this.cac_movcar["id"] == 0){
        for (var i = 0; i < this.cac_movcar["detalleTesoreria"].length; ++i) {
          if(i == 0 )
            this.cac_movcar["detalleTesoreria"][i].valor = valtotal.toFixed(2);
          else{
            this.cac_movcar["detalleTesoreria"].splice(i, this.cac_movcar["detalleTesoreria"].length-1);
          }
        }
      }
    }

  }

  calcularTotalMovimiento(){
    var detalleCartera = [];
    var count =0;
    var valtotal=0;
    for (var i = 0; i < this.carteras.length; ++i) {
      if(this.carteras[i].valor > 0 || this.cac_movcar["id"]!=0){
        this.carteras[i].fila = ++count;
        valtotal += parseFloat(this.carteras[i].valor);
        detalleCartera.push(this.carteras[i]);
      }
    }
    this.cac_movcar["valtotal"]= valtotal.toFixed(2);
    this.cac_movcar["detalle"]= detalleCartera;

    return valtotal;
  }

  eliminarPago(index){
    if(this.cac_movcar["id"] == 0 || this.cac_movcar["detalleTesoreria"][index].iddoctes == 0)
      this.cac_movcar["detalleTesoreria"].splice(index,1);
    else
      this.cac_movcar["detalleTesoreria"][index].idestado=1;
  }

  segmentChanged(event){
    if(event.value == "buscar"){
      let loading = this.loadingCtrl.create({
        content: 'Cargando, espere por favor...'
      });
      loading.present();

      this.movcarService.get(1, 0).subscribe(val => {
        if (val != undefined){
          this.listcac_movcar = [];
          this.listcac_movcar_estatica = [];
          for (var i = 0; i < val.length; i++) {
            this.listcac_movcar.push(val[i]);
            this.listcac_movcar_estatica.push(val[i]);
          }
        }
        loading.dismiss();
      });
    }
  }

  buscarMovimiento(item){
    let loading = this.loadingCtrl.create({
      content: 'Cargando, espere por favor...'
    });

    loading.present();
    this.movcarService.get(1, item.id).subscribe(val => {
      if (val != undefined){
        this.cac_movcar["id"]= val.id;
        this.cac_movcar["fecha"] = val.fecha;
        this.cac_movcar["idtmovcar"]=val.idtmovcar;
        this.cac_movcar["idempresa"]=1;
        this.cac_movcar["idestado"]=val.idestado;
        this.cac_movcar["observacion"]= val.observacion;
        this.cac_movcar["idmovimiento"]= null;
        this.cac_movcar["detalle"]= null;
        this.cac_movcar["identidade"] = val.identidade;
        this.cac_movcar["identidadp"] = val.identidadp;
        this.cac_movcar["identidadd"] = val.identidadd;
        this.cac_movcar["sn_destino"] = (val.identidadd == null) ? false : true;
        this.carteras = [];
        var totDeuda=0, totsaldo=0;
        for (var i = 0; i < val.detalle.length; i++) {
          totDeuda += parseFloat(val.detalle[i].deuda);
          totsaldo += parseFloat(val.detalle[i].valdeuda);

          this.carteras.push({
              pagar:true,
              idmovcar: val.detalle[i].idmovcar,
              fila:val.detalle[i].fila,
              idcartera: val.detalle[i].idcartera,
              fechaini: val.detalle[i].fechaini,
              fechacar: val.detalle[i].fechacar,

              ndepartamento: val.detalle[i].ndepartamento,
              codigodep: val.detalle[i].codigodep,
              concepto: val.detalle[i].concepto,
              medida: val.detalle[i].medida,
              cantidad: val.detalle[i].idconcepto == 1 ? 1 : val.detalle[i].cantidad,

              deuda: parseFloat(val.detalle[i].deuda),
              valor: parseFloat(val.detalle[i].valor).toFixed(2),
              valsaldo: parseFloat(val.detalle[i].valdeuda),
              idestado:0
            });
          
        }
        this.cac_movcar["detalle"]= this.carteras;

        this.cac_movcar["operador"] = val.operador;

        this.cac_movcar["proveedor"] = val.proveedor + (this.carteras[0].ndepartamento == undefined ? '' : ' - (' + this.carteras[0].ndepartamento + " - " + this.carteras[0].codigodep + ')');
        this.cac_movcar["destinatario"] = val.destinatario;
        this.cac_movcar["valdeuda"] = totDeuda.toFixed(2);
        this.cac_movcar["valtotal"] = parseFloat(val.valtotal);
        this.cac_movcar["valsaldo"] = totsaldo.toFixed(2);

        var detTesoreria=[];
        for (var j = 0; j < val.detalleTesoreria.length; j++) {

          var detalle = { iddoctes:val.detalleTesoreria[j].iddoctes,
              idtdoctes:val.detalleTesoreria[j].idtdoctes,
              idcuenta:val.detalleTesoreria[j].cabecera.idcuenta,
              referencia:val.detalleTesoreria[j].cabecera.referencia,
              valor:parseFloat(val.detalleTesoreria[j].cabecera.valor).toFixed(2),
              idestado:0
          };
          detTesoreria.push(detalle);
          this.getCuentas(detalle);
        }
        this.cac_movcar["detalleTesoreria"]= detTesoreria;
        

        this.pet = "ingreso";
      }
      loading.dismiss();
    });
    
  }


  guardarMovimiento(imprime:boolean){
    this.calcularTotalMovimiento();
    for (var i = 0; i < this.cac_movcar["detalleTesoreria"].length; ++i) {
      if(parseFloat(this.cac_movcar["detalleTesoreria"][i].valor) == 0){
        this.eliminarPago(i);
      }
    }
    

    let totalMovCar:number = parseFloat(this.cac_movcar["valtotal"]);
    let valdoctes = this.calcularTotalTesoreria(this.cac_movcar["detalleTesoreria"]);

    if(totalMovCar == 0 || totalMovCar.toFixed(2) != valdoctes.toFixed(2)){
      let mensaje = (totalMovCar == 0) ? 'Realice los respectivos ingresos a realizar' : 'El valor total del movimiento no cuadra con el registro de tesorería.';
        let alert = this.alertCtrl.create({
          title: 'Validacion de datos',
          subTitle: mensaje,
          buttons: ['OK']
        });
        alert.present();
    }
    else{
      this.loading = this.loadingCtrl.create({ content: 'Cargando, espere por favor...' });
      this.loading.present();
      let params = { 
            id: this.cac_movcar["id"], 
            idempresa: this.cac_movcar["idempresa"], 
            correo: '', 
            ndepartamento: this.carteras[0].ndepartamento + " - " + this.carteras[0].codigodep, 
            entidad: this.cac_movcar["proveedor"]
          };

      this.movcarService.guardar(this.cac_movcar).then((result) => {
        if(imprime){
          console.log(result);
          params.id = result["id"];
          this.imprimir(params, true);
        }
        else{
          this.nuevo();
          this.loading.dismiss();
        }
      }).catch(error => {
        console.log(error);
        this.loading.dismiss();
      });
    }
  }

  imprimirItem(item){
    this.loading = this.loadingCtrl.create({ content: 'Cargando, espere por favor...' });
    this.loading.present();
    let params = { id: item.id, idempresa: item.idempresa, correo: '', 
      ndepartamento: item.ndepartamento+'-'+ item.codigodep, entidad: item.entidad };
    this.imprimir(params, false);
  }

  imprimir(params, vaciar:boolean){
    this.movcarService.getReporte(params.idempresa, params.id).then(data=>{
      const myModalOptions: ModalOptions = {
        enableBackdropDismiss: false,
        cssClass : 'modal-correo'
      }
      params.correo = (data["identidadd"] == null) ? data["correop"] : data["correod"];
      params.entidad = (data["identidadd"] == null) ? data["proveedor"] : data["destinatario"];

      let modal = this.modalCtrl.create(EnviocorreoPage, params, myModalOptions);
      modal.present();
      if(vaciar) this.nuevo();
      this.loading.dismiss();
    },(err) => {
        if(vaciar) this.nuevo();
        this.loading.dismiss();
     });
  }

  filtrar(ev: any) {
    this.listcac_movcar = this.listcac_movcar_estatica.slice();
    let val = ev.target.value;
    //console.log(this.listcac_movcar)
    if (val && val.trim() != '') {
      this.listcac_movcar = this.listcac_movcar.filter((item) => {
        return (item.entidad.toLowerCase().indexOf(val.toLowerCase()) > -1 || 
          (item.ndepartamento != null && item.ndepartamento.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.codigodep != null && item.codigodep.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          item.valtotal.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
          item.fecha.toLowerCase().indexOf(val.toLowerCase()) > -1 );
      })
    }
  }

  eliminarMovimiento(item) {
    let confirm = this.alertCtrl.create({
      title: 'Eliminación de datos',
      message: 'Esta seguro de eliminar el movimiento de cartera?',
      buttons: [
        {
          text: 'Cancelar',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Aceptar',
          handler: () => {
            let loading = this.loadingCtrl.create({
              content: 'Eliminando..'
            });

            this.movcarService.eliminar(item.id);
            

            loading.present();

            setTimeout(() => {
              
              this.segmentChanged({value: 'buscar' });
              this.nuevo();
              loading.dismiss();
            }, 5000);
          }
        }
      ]
    });
    confirm.present();
  }

  nuevoPago(){
    this.agregarTesoreria(this.cac_movcar["detalleTesoreria"]);
  }

}



// WEBPACK FOOTER //
// ./src/pages/movimiento-cartera/movimiento-cartera.ts